import { createSlice } from "@reduxjs/toolkit";
import { CallCost } from "./type";
import { getCallCosts } from "./thunk";

interface CallCostsState {
  data: CallCost | null;
  loading: boolean;
  error: string | null;
}

const initialState: CallCostsState = {
  data: null,
  loading: false,
  error: null,
};

export const callCostsSlice = createSlice({
  name: "callCosts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCallCosts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCallCosts.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getCallCosts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Something went wrong";
      });
  },
});

export default callCostsSlice.reducer;
